import { render, staticRenderFns } from "./_id.baseLayout.vue?vue&type=template&id=af53ba0c&scoped=true"
import script from "./_id.baseLayout.vue?vue&type=script&lang=js"
export * from "./_id.baseLayout.vue?vue&type=script&lang=js"
import style0 from "./_id.baseLayout.vue?vue&type=style&index=0&id=af53ba0c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af53ba0c",
  null
  
)

export default component.exports